"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewerSteps = exports.ownerSteps = exports.baseSteps = exports.defaultCriteria = exports.evaluationOptions = exports.winTypes = void 0;
const types_1 = require("./types");
exports.winTypes = [
    {
        type: types_1.WinType.BALLOT,
        name: 'Ballot',
    },
    {
        type: types_1.WinType.SIMPLEPOLL,
        name: 'Basic Poll',
    },
    {
        type: types_1.WinType.EVALUATIONPOLL,
        name: 'Multi-Criteria Poll',
    },
    {
        type: types_1.WinType.AI,
        name: 'AI',
    },
];
exports.evaluationOptions = [
    'Clarity',
    'Evidence',
    'Organization',
    'Delivery',
    'Overall Impact',
    'Rebuttal Strength',
    'Persuasiveness',
    'Use of Time',
    'Logical Structure',
    'Engagement',
];
exports.defaultCriteria = ['Clarity', 'Evidence', 'Organization', 'Delivery', 'Overall Impact'];
exports.baseSteps = [
    {
        target: 'body',
        content: "Welcome to DB8AI.com! Let's take a quick tour to familiarize you with the app.",
        placement: 'center',
        disableBeacon: true,
    },
    {
        target: '#controls',
        content: 'These are the video controls for managing the debate.',
        placement: 'top',
    },
    {
        target: '#inviteCode',
        content: 'Copy this invite code and share it with friends to invite them to join the debate.',
        placement: 'top-end',
    },
];
const flowNotes = {
    title: 'Flow Notes',
    target: '#flowNotesBtn',
    content: 'These are your automated flow notes. Our AI Judge analyzes each user’s position and responses, then generates concise yet detailed points after each turn to help participants prepare for the next.',
    placement: 'top-end',
};
const guidebook = {
    title: 'Guidebook',
    target: '#guidebookBtn',
    content: 'The Guidebook contains essential information about the debate format, rules, speaker roles, and timing. It serves as a quick reference to help both new and experienced participants navigate the app and structure their arguments effectively.',
    placement: 'top-end',
};
const evidence = {
    title: 'Evidence',
    target: '#evidenceBtn',
    content: 'The Evidence section allows users to upload sources, summaries, and supporting content for their arguments. Each submission is scored by AI for reliability, helping participants evaluate and build stronger, well-supported cases.',
    placement: 'top-end',
};
const ballot = {
    title: 'Ballot',
    target: '#ballotBtn',
    content: 'The Ballot system is where judges cast votes, assign points, and leave feedback. Depending on the selected format, ballots can be simple, rubric-based, or involve AI-assisted scoring. Results can be used to determine the round’s winner.',
    placement: 'top-end',
};
const polling = {
    title: 'Polling',
    target: '#pollingBtn',
    content: 'Polling is how judges or spectators vote on the outcome of a debate. In Simple Poll mode, voters choose which team they believe won overall. In Multi-Criteria Poll mode, voters rate each team across categories like clarity, evidence and organization — allowing for more detailed scoring.',
    placement: 'top-end',
};
exports.ownerSteps = [
    ...exports.baseSteps,
    {
        target: '#panels',
        content: 'Here, you can monitor the current status of the debate. Use hotkeys for quick navigation, and hold Shift + hotkey to control a second panel.',
        placement: 'top-start',
    },
    {
        title: 'Debate Sequence',
        target: '#sidePanel',
        content: "Once each team has at least one participant, head here to assign participants to their respective stages in the debate. Once the stages are set, you'll be able to start and stop each participant's turn.",
        placement: 'left-start',
    },
    {
        title: 'Chat',
        target: '#sidePanel',
        content: 'Moderate the chat to ensure that all participants are following the rules and behaving appropriately.',
        placement: 'left-start',
    },
    {
        title: 'Participants',
        target: '#sidePanel',
        content: 'Drag and drop participants to assign them to their teams. Moderators can also add or remove participants, and control their microphones or webcams. Once the debate is initialized, participants cannot be moved.',
        placement: 'left-start',
    },
    {
        title: 'Settings',
        target: '#sidePanel',
        content: 'Modify the app settings as needed. Note that once the debate is initialized, the debate format cannot be changed.',
        placement: 'left-start',
    },
    guidebook,
    flowNotes,
    evidence,
    ballot,
    polling,
];
exports.viewerSteps = [
    ...exports.baseSteps,
    {
        target: '#panels',
        content: "As a viewer, you can observe the debate and explore the app's features. More options will appear as data from the debate is generated. Once the debate ends, you'll be able to export all transcripts and the final AI judgment.",
    },
    guidebook,
    flowNotes,
    evidence,
    ballot,
    polling,
];
